import {lazy, Suspense} from 'react';
import LoadingPage from '../containers/loading';

const GeneralSettingsPage = lazy (() =>
  import ('../components/settings/general/generalSettings.component')
);

export default function GeneralSettingsRoute () {
  return (
    <Suspense fallback={<LoadingPage />}>
      <GeneralSettingsPage />
    </Suspense>
  );
}
